import { getNextSibling } from "../utils/dom";

export default class TinyMCE extends HTMLTextAreaElement {

    connectedCallback() {

        if (this.dataset.mode === "defer")
            return;

        this.loadEditor();

    }

    loadEditor() {
        if ("tinymce" in window && !this.hasEditor) {
            this.initEditor();
            return;
        }

        import(/*webpackIgnore: true*/ '../tinymce/tinymce.min.js').then(module => {
            this.initEditor();
        });
    }

    initEditor() {
        tinymce.init({
            base_url: "/static/bundles/tinymce/",
            target: this,
            plugins: 'lists advlist, autolink, link',
            branding: false,
            toolbar: 'undo redo | bold | bullist | link ',
            //language: 'sv_SE',
            menubar: false,
            statusbar: false,
            skin: 'tinymce-5',
            theme: 'silver',
            setup: function (editor) {
                editor.on('change blur', function (e) {
                    e.target.targetElm.value = editor.getContent();
                });
            },
        });
    }

    disconnectedCallback() {


    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-mode" && newValue !== "defer") {
            this.loadEditor();
        }
    }

    static get observedAttributes() { return ["data-mode"]; }

    get hasEditor() {
        return "tinymce" in window && tinymce.get(this) !== null;
    }

}

customElements.define('tiny-mce', TinyMCE, { extends: 'textarea' });